// Importando funciones de funciones.js
import { 
    apertura,
    updateActiveClass,
    llena_bannerspub,
    reproduce_video_youtube,
    reproduce_video_modulo,
    activa_Transmision,
    registrarEventoEnLaApiMetaAds     
} from './funciones.js'; 

(function() {
    'use strict';

    const path = window.location.pathname;

    // ? VARIABLES 
    var idSoftware = 2;   

    console.log(path);
    
    
    // Obtener todos los enlaces del menú en un array
    const menuLinks = Array.from(document.querySelectorAll('.nav_links'));    

    let heros = [];      

    const messages = [
        {
            title: "Controla tu Restaurante como un Profesional",
        },
        {
            title: "Inventarios, Ventas y Mesas en un Solo Sistema", 
        },
        {
            title: "Soporte Técnico en Vivo, Sin Bots ni Esperas",
        },
        {
            title: "Miles de Restauranteros ya Usan BDKREST",
        }
    ];

    document.addEventListener('DOMContentLoaded', () => {

        //! MENU LATERAL EN VERSIONES TABLET Y MOVIL

        const botMenu = document.getElementById('botMenu');

        if (botMenu) {
            botMenu.addEventListener('click', function(event) {
                event.preventDefault();  // Evitar que la página se mueva al inicio
                apertura();
            });
        }

        // ! CÓDIGO PARA QUE CUANDO SE DE CLICK EN UN ENLACE DEL MENU CUANDO ES VERSIÓN MÓVIL, SE CIERRE.
        const menu = document.getElementById('navPrincipal');
        const enlacesMenu = document.querySelectorAll('#navPrincipal .nav_links');
        
        enlacesMenu.forEach((enlace) => {
            enlace.addEventListener('click', () => {
                // Verifica si el menú tiene la clase 'menu2'
                if (menu.classList.contains('menu2')) {
                    // Si la tiene, la eliminamos
                    menu.classList.remove('menu2');
                }
            });
        });    

        // ! Escuchar el evento de desplazamiento y actualizar la clase 'nav_active'
        // ! La cual me sirve para marcar en que sección de la página me encuentro.

        window.addEventListener('scroll', () => updateActiveClass(menuLinks));        

        // ! Actualizar la clase 'nav_active' cuando la página se carga
        window.addEventListener('load', () => updateActiveClass(menuLinks));        

        //! Visualizando los banners de publicidad
        const div_pub = document.getElementById('div_pub');

        if (div_pub !== null) {
            llena_bannerspub(div_pub);             
        };

        //! Monitoreando los enlaces del botón PLAY para reproducir vídeos de Youtube en el DOM
        const playLink = document.querySelector('.play');
        if (playLink) {
            document.querySelectorAll('.play').forEach(link => {
                link.addEventListener('click', reproduce_video_youtube);
            }); 
        }

        //! Monitoreando los enlaces del botón PLAY para reproducir vídeos de Youtube en el DOM
        const playModulo = document.querySelector('.play-modulo');
        if (playModulo) {

            document.addEventListener("click", function (e) {
                const playBtn = e.target.closest(".play-modulo");
                if (playBtn) {
                    reproduce_video_modulo(e);
                }
            });

        }

        //! Mantiene actualizado el año en la línea de los Derechos de Autor (PIE DE PÁGINA)
        document.addEventListener('contentIncluded', () => {
            const year = new Date().getFullYear(); // Obtiene el año actual
            const yearElement = document.getElementById('current-year');
            if (yearElement) {
                yearElement.textContent = year; // Establece el año en el elemento span
            }
        });

        //! Activando las Transmisiones en Vivo
        if (document.getElementById("secTransmisiones")) {

            activa_Transmision();
        
        };

        //! PÁGINA INDEX.HTML

        if (path === '/' || path.includes('index.html')) {
            (async () => {
                try {
                    const { next_fondo,
                            iniciaSlider,
                            updateMessage,
                            cycleMessages,
                            cargarPrecios,
                            cargarFondosDinamicos,
                            iniciarCicloDeFondos,
                            cargaPromocion 

                    } = await import('./inicio.js');

                    // ! Registrando el evento en la API de Conversiones de Meta Ads

                    registrarEventoEnLaApiMetaAds("ViewContent", null, null, null)
                        .catch(error => {
                            console.error("Hubo un error al enviar el evento ViewContent a Meta Ads al consultar la información de una comunidad:", error.message);
                        });

                    // Fondo dinámico (post-LCP)
                    // Verificar si el dispositivo es móvil (ancho máximo de 480px)
                    const esMovil = window.matchMedia('(max-width: 480px)').matches;

                    const imagenesFondo = esMovil
                        ? [
                            'build/img/bdkrest-bkg2-movil.webp',
                            'build/img/bdkrest-bkg3-movil.webp',
                            'build/img/bdkrest-bkg4-movil.webp',
                            'build/img/bdkrest-bkg5-movil.webp',
                            'build/img/bdkrest-bkg1-movil.webp',
                        ]
                        : [
                            'build/img/bdkrest-bkg2.webp',
                            'build/img/bdkrest-bkg3.webp',
                            'build/img/bdkrest-bkg4.webp',
                            'build/img/bdkrest-bkg5.webp',
                            'build/img/bdkrest-bkg1.webp',
                        ];

                    const fondosHeroContainer = document.getElementById('fondosHero');                    

                    setTimeout(() => {
                        cargarFondosDinamicos(imagenesFondo, fondosHeroContainer);
                        setTimeout(() => iniciarCicloDeFondos(next_fondo, fondosHeroContainer), 500);
                    }, 3000);

                    // Sliders
                    iniciaSlider();

                    // Banda de mensajes
                    const titleElement = document.getElementById('message-title');
                    const containerElement = document.getElementById('message-container');
                    const indicators = document.querySelectorAll('#indicators span');
                    let currentIndex = 0;

                    if (containerElement) {
                        updateMessage(messages, titleElement, indicators, containerElement, currentIndex);
                        cycleMessages(messages, titleElement, indicators, containerElement, currentIndex);
                    }

                    // Precios
                    const div_precios = document.getElementById('sec-precios');
                    if (div_precios) {
                        cargarPrecios(idSoftware); 
                    }

                    // Promoción
                    const div_promocion = document.getElementById('area-promocion');
                    if (div_promocion) {
                        cargaPromocion(); 
                    }

                    // Acordeón
                    $('.accordion-content').hide();
                    $('.accordion-button').attr('aria-expanded', 'false');

                    $('.accordion-button').on('click', function() {
                        const isExpanded = $(this).attr('aria-expanded') === 'true';
                        $(this).attr('aria-expanded', !isExpanded);
                        $(this).next('.accordion-content').slideToggle();

                        if (!isExpanded) {
                            $('.accordion-content').not($(this).next()).slideUp();
                            $('.accordion-button').not(this).attr('aria-expanded', 'false');
                        }
                    });

                } catch (error) {
                    console.error('Error al cargar las funciones de inicio.js:', error);
                }
            })();
        }

        //! PÁGINA BLOG.HTML

        if (path.includes('blog.html')) {

            const page_blog = document.getElementById('pagina-cards-blog');

            if (page_blog !== null) {

                (async () => {
                    try {
                        const { llenarPageBlog } = await import('./blog.js');
                        llenarPageBlog(page_blog, idSoftware);
                    } catch (error) {
                        console.error('Error al cargar funciones del blog.js:', error);
                    }
                })();

            }
        }

        //! PÁGINA NOTICIA.HTML

        if (path.includes('noticia.html')) {
            (async () => {
                try {
                    const { getParameterByName, mostrarDetallesBlog } = await import('./blog.js');
                    const blogId = getParameterByName('id');
                    if (blogId) {
                        mostrarDetallesBlog(blogId);
                    }
                } catch (error) {
                    console.error('Error al cargar funciones de blog.js en noticia.html:', error);
                }
            })();
        }

        //! Obteniendo el link de descarga del software        
        const pasosDescarga = document.getElementById('pasos-para-descargar');

        if (pasosDescarga) {        

            (async () => {
                try {
                    const { info_Software } = await import('./varios.js');
                    info_Software(idSoftware);
                } catch (error) {
                    console.error('Error al cargar los pasos para descargar | varios.js:', error);
                }
            })();
        }

        //! PÁGINA CAPACITACION.HTML

        if (path.includes('capacitacion.html')) {

            // Obteniendo el listado de lecciones para la página de Capacitación

            const capacitacionSection = document.getElementById('capacitacion');
            
            if (capacitacionSection) {
                
                // Llamar a la función para cargar las categorías y las lecciones

                (async () => {
                    try {
                        const { cargarCategoriasYLecciones } = await import('./capacitacion.js');
                        cargarCategoriasYLecciones();
                } catch (error) {
                        console.error('Error al cargar los pasos para descargar | varios.js:', error);
                    }
                })();
            }
           
        }

        //! ------------------------------------------------------
        //* Enviando el formulario de contacto por correo EMail
        //* Validado con Google reCaptcha
        //! ------------------------------------------------------

        const contactForm = document.getElementById('contact-form');

        if(contactForm) {

            contactForm.addEventListener("submit", function(event) {
                event.preventDefault();
            
                const token = grecaptcha.getResponse(); // Obtiene el token del reCAPTCHA
                if (!token) {
                    Swal.fire({
                        title: 'Error',
                        text: 'Por favor, verifica que no eres un robot.',
                        icon: 'error',
                        confirmButtonText: 'Cerrar' 
                    });
                    return;
                }
            
                fetch('/scripts/verify-recaptcha.php', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    body: new URLSearchParams({ token: token })
                })
                .then(response => response.json())
                .then(data => {

                    if (data.success) {

                        // Captura los valores de los campos del formulario

                        const userName = document.getElementById("user_name").value;
                        const userPhone = document.getElementById("user_phone").value;
                        const userEmail = document.getElementById("user_email").value;
                        const userCiudad = document.getElementById("user_ciudad").value;
                        const userMessage = document.getElementById("user_message").value;

                        // Configura los parámetros para enviar con EmailJS

                        const templateParams = {
                            user_name: userName,
                            user_phone: userPhone,
                            user_email: userEmail,
                            user_ciudad: userCiudad,
                            user_message: userMessage
                        };

                        // Usa EmailJS para enviar el correo
                        emailjs.send("service_5jaisje", "template_q8m0x7f", templateParams)
                        .then(function(response) {

                            Swal.fire({
                                title: 'Correo Enviado',
                                text: 'Tu correo fue envíado correctamente. En breve recibirás noticias.',
                                icon: 'success',
                                confirmButtonText: 'Cerrar'
                            });

                            const estaEnContacto = window.location.pathname.endsWith("contacto.html");

                            // ! Registrando la conversión de Google

                            // Ejecutar solo si gtag está definido
                            if (typeof gtag !== "undefined") {

                                // Paso 1: Enviar datos de usuario para la conversión mejorada
                                gtag('set', 'user_data', {
                                    email: userEmail,
                                    phone_number: userPhone,
                                    first_name: userName
                                });

                                // Paso 2: Registrar la conversión manualmente
                                gtag('event', 'conversion', {
                                    'send_to': 'AW-1011948451/W1fCCOW17NgaEKO3xOID'
                                });
                            }

                            // Limpiar el formulario
                            contactForm.reset();
                            grecaptcha.reset();                            

                            registrarEventoEnLaApiMetaAds("Lead", userEmail, userPhone, userName)
                                .catch(error => {
                                    console.error("Error al registrar el evento Lead en Meta Ads:", error.message);
                                });

                            if (estaEnContacto) {

                                // Se deja este timeout para asegurar que las conversiones se registraro correctamente. 
                                setTimeout(() => {
                                    window.location.href = 'graciasporcontactarnos.html';
                                }, 400);

                            }

                        }, function(error) {

                            Swal.fire({
                                title: 'Error',
                                text: 'Hubo un error al enviar el mensaje. Inténtalo nuevamente.',
                                icon: 'error',
                                confirmButtonText: 'Cerrar'
                            });

                            console.error("Error:", error);

                        });

                    } else {
                        Swal.fire({
                            title: 'Error en la verificación',
                            text: data.message || 'No se pudo verificar tu solicitud. Inténtalo nuevamente.',
                            icon: 'error',
                            confirmButtonText: 'Cerrar'
                        });
                        console.error('Detalles:', data);
                    }
                })
                .catch(error => {
                    Swal.fire({
                        title: 'Error',
                        text: 'Hubo un problema al validar el reCAPTCHA. Inténtalo nuevamente.',
                        icon: 'error',
                        confirmButtonText: 'Cerrar'
                    });
                    console.error('Error en la solicitud:', error);
                });
            });
                        
        }

        //! Incerceptando botón widget del WhatsApp para saber si se abre en el navegador o en un teléfon

        document.addEventListener("click", function (e) {

            if (e.target.closest("#whatsapp-btn")) {

                e.preventDefault();

                // Código de Conversión de Google Ads
                 gtag('event', 'conversion', {'send_to': 'AW-1011948451/_RaqCL7aydMaEKO3xOID'});

                // ! Registrando el evento en la API de Conversiones de Meta Ads

                registrarEventoEnLaApiMetaAds("Contact", null, null, null)
                    .catch(error => {
                        console.error("Hubo un error al enviar el evento Contact a Meta Ads al consultar la información de una comunidad:", error.message);
                    });

                const phone = "528132814080";
                const message = "Quiero informes del software para restaurantes";
                const encodedMessage = encodeURIComponent(message);

                const isMobile = /iPhone|Android|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
                const baseUrl = isMobile
                    ? "https://api.whatsapp.com/send"
                    : "https://web.whatsapp.com/send";

                const url = `${baseUrl}?phone=${phone}&text=${encodedMessage}`;

                // Pequeño retraso para asegurar que se envía el evento de conversión a Google antes de abrir la URL
                setTimeout(() => {
                    window.open(url, "_blank");
                }, 400);
                       
            }
        });

    });

})();